import type { TUser } from '@shared/types/user';
import type { TInterviewer } from '@shared/types/interviewer';
import type { TOrganization } from '@shared/types/organization';
import type { TCountry } from '@shared/types/country';
import type { ValueOf } from '@shared/types/utilities';
import type { TMeetingNote } from '@shared/types/meeting-note';

const APPOINTMENTS_STATUS = {
  scheduled: 'SCHEDULED',
  rescheduled: 'RESCHEDULED',
  inProgress: 'IN_PROGRESS',
  completed: 'COMPLETED',
  canceled: 'CANCELLED',
  noShow: 'NO_SHOW',
} as const;

const APPOINTMENTS_PLATFORMS = {
  google: 'GOOGLE_MEET',
  microsoft: 'MICROSOFT_TEAMS',
  zoom: 'ZOOM',
  other: 'OTHER',
} as const;

const APPOINTMENTS_TYPES = {
  online: 'ONLINE',
  onsite: 'ONSITE',
} as const;

const APPOINTMENTS_INTERVIEW_TYPES = {
  employerInterview: 'EMPLOYER_INTERVIEW',
  visaInterview: 'VISA_INTERVIEW',
  screeningInterview: 'SCREENING_INTERVIEW',
  others: 'OTHERS',
} as const;

type TAppointment = {
  id: number;
  lead: number;
  organization: TOrganization;
  created_by: TUser;
  participant: TUser;
  timezone: string;
  host: TInterviewer;
  country: TCountry;
  created_at: string;
  updated_at: string;
  unique_id: string;
  participant_name: string;
  participant_email: string;
  name: string;
  description: string;
  status: ValueOf<typeof APPOINTMENTS_STATUS>;
  start_time: string;
  end_time: string;
  type: ValueOf<typeof APPOINTMENTS_TYPES>;
  platform: ValueOf<typeof APPOINTMENTS_PLATFORMS>;
  link: string;
  location: string;
  via_calendly: boolean;
  calendly_id: string;
  metadata: string;
  interviewer_name: string;
  interviewer_email: string;
  interviewer_job_title: string;
  interviewer_company_name: string;
  interview_type: ValueOf<typeof APPOINTMENTS_INTERVIEW_TYPES>;
  city: string;
  note: string;
  notes: TMeetingNote[];
};

export {
  APPOINTMENTS_STATUS,
  APPOINTMENTS_PLATFORMS,
  APPOINTMENTS_TYPES,
  APPOINTMENTS_INTERVIEW_TYPES,
  type TAppointment,
};
